// extracted by mini-css-extract-plugin
export default {"palh":"#2cced2","pal0":"#ff5656","pal1":"#ffcc37","pal2":"#84c825","pal3":"#1875c3","pal4":"#6f4b92"};